import React from 'react';

import { ListingPageFilterBar } from '@futrli/ui-components/components/listing-page/listing-page-filter-bar/listing-page-filter-bar';

import { SortByFilter } from './components/sort-by-filter';
import { StatusFilter } from './components/status-filter';

interface MyDashboardsFilterBarProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  statusFilterValue: string;
  onStatusFilterChange: (value: string) => void;
  sortByFilterValue: string;
  onSortByFilterChange: (value: string) => void;
  stickyTop?: number;
  isResourceSharingEnabled?: boolean;
}

export const MyDashboardsFilterBar = ({
  searchTerm,
  onSearchChange,
  statusFilterValue,
  onStatusFilterChange,
  sortByFilterValue,
  onSortByFilterChange,
  stickyTop,
  isResourceSharingEnabled = false
}: MyDashboardsFilterBarProps) => {
  return (
    <ListingPageFilterBar
      searchTerm={searchTerm}
      onSearchChange={onSearchChange}
      rightContent={<SortByFilter onChange={onSortByFilterChange} selectedValue={sortByFilterValue} />}
      stickyTop={stickyTop}
    >
      <StatusFilter
        onChange={onStatusFilterChange}
        selectedValue={statusFilterValue}
        isResourceSharingEnabled={isResourceSharingEnabled}
      />
    </ListingPageFilterBar>
  );
};
